import React, { useState } from "react";
import { Col, Row, Card, CardBody, Collapse, Tooltip } from "reactstrap";
import { Link } from "react-router-dom";
import config from "config";
import {
  FiLink,
  FiUser,
  FiInfo,
  FiChevronDown,
  FiChevronUp,
} from "react-icons/fi";
import { BsFillInfoCircleFill } from "react-icons/bs";

const IdentificationCard = ({
  title,
  details,
  ids,
  isAccordionOpen = true,
  setIsAccordionOpen = () => {},
  tooltips = {}, // données des tooltips passées en props
}) => {
  const Config = config;
  const { url: backUrl, appName } = Config;

  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

  const toggleTooltip = (key) => {
    setTooltipOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  function sanitizeSelector(str) {
    // Remplace les espaces et caractères non valides par des underscores
    let sanitized = str.replace(/[^a-zA-Z0-9_-]/g, "_");
    // Si la chaîne commence par un chiffre, ajoute un underscore au début
    if (/^\d/.test(sanitized)) {
      sanitized = "_" + sanitized;
    }
    return sanitized;
  }

  return (
    <Card
      className="shadow-sm border-0 overflow-hidden"
      style={{ borderRadius: "12px" }}
    >
      {/* En-tête cliquable */}
      <div
        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
        style={{
          background: "#555B21",
          letterSpacing: "0.5px",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={toggleAccordion}
      >
        <div className="d-flex align-items-center">
          {/* <FiUser size={16} className="me-2" /> */}
          <span style={{ fontSize: "0.82rem" }}>{title}</span>
        </div>
        {isAccordionOpen ? (
          <FiChevronUp size={16} />
        ) : (
          <FiChevronDown size={16} />
        )}
      </div>

      {/* Contenu repliable */}
      <Collapse isOpen={isAccordionOpen}>
        <CardBody className="p-0">
          <div className="fields-container" style={{ paddingBottom: "8px" }}>
            {Object.entries(details)
              .filter(
                ([key, value]) => typeof value !== "object" || value === null
              )
              .map(([key, value], index) => {
                const safeKey = sanitizeSelector(key.replace(/([:])/g, "\\$1"));
                return (
                  <div
                    key={index}
                    className="field-item px-2 py-1"
                    style={{
                      backgroundColor: "white",
                      transition: "all 0.15s ease",
                      borderLeft: "3px solid transparent",
                      position: "relative",
                      cursor: "default",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e3f2fd";
                      e.currentTarget.style.borderLeftColor = "#007bff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.style.borderLeftColor = "transparent";
                    }}
                  >
                    {/* Ligne de séparation subtile */}
                    {index > 0 && (
                      <div
                        className="field-separator"
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          right: 0,
                          height: "1px",
                          background:
                            "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                        }}
                      />
                    )}

                    <Row className="align-items-center g-1">
                      {/* Label avec tooltip */}
                      <Col xs={12} md={4} className="field-label">
                        <div className="d-flex align-items-center small text-muted">
                          <span
                            className="fw-medium position-relative"
                            id={`Tooltip-${safeKey}`}
                            style={{
                              fontSize: "0.8rem",
                              letterSpacing: "0.2px",
                            }}
                          >
                            {key}
                          </span>
                          {tooltips[key] && (
                            <>
                              <span
                                style={{
                                  display: "inline-flex",
                                  padding: "6px", // élargit la zone autour de l'icône
                                  cursor: "pointer",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                id={`Info-${safeKey}`}
                              >
                                <BsFillInfoCircleFill
                                  size={14}
                                  className="text-info"
                                />
                              </span>
                              <Tooltip
                                placement="right"
                                isOpen={tooltipOpen[key]}
                                target={`Info-${safeKey}`}
                                toggle={() => toggleTooltip(key)}
                                delay={{ show: 0, hide: 100 }}
                              >
                                {tooltips[key]}
                              </Tooltip>
                            </>
                          )}

                          <span className="ms-1 text-primary">:</span>
                        </div>
                      </Col>

                      {/* Valeur */}
                      <Col xs={12} md={8} className="field-value">
                        <div
                          style={{
                            fontSize: "0.8rem",
                            padding: "3px 6px",
                            borderRadius: "6px",
                            backgroundColor: "#fff",
                            transition: "all 0.2s ease",
                            minHeight: "26px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {renderValue(key, value, ids, appName, backUrl)}
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              })}
          </div>
        </CardBody>
      </Collapse>
    </Card>
  );
};

const renderValue = (key, value, ids, appName, backUrl) => {
  if (!value && value !== 0)
    return <span className="text-muted fst-italic">—</span>;

  const LinkWrapper = ({ to, onClick, children }) => (
    <Link
      to={to}
      onClick={onClick}
      className="text-decoration-none fw-medium text-primary d-inline-flex align-items-center"
      style={{
        transition: "all 0.2s ease",
        fontSize: "0.8rem",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "scale(1.02)";
        e.target.style.boxShadow = "0 0 0 2px rgba(13, 110, 253, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "scale(1)";
        e.target.style.boxShadow = "none";
      }}
    >
      <FiLink size={9} className="me-1" />
      {children}
    </Link>
  );

  const formatNum = (val, decimals) => (
    <span className="" style={{ fontSize: "0.8rem" }}>
      {(
        Math.floor(val * Math.pow(10, decimals)) / Math.pow(10, decimals)
      ).toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
      })}{" "}
    </span>
  );

  // Formatage des nombres
  if (typeof value === "number") {
    if (key === "Année de début")
      return (
        <span className="fw-semibold text-info" style={{ fontSize: "0.8rem" }}>
          {value}
        </span>
      );
    if (key === "Price per share") return formatNum(value, 4);
    if (key === "Share nav" || key === "Investment nav" || key.includes("Rate"))
      return formatNum(value, 6);
    if (
      !["Builder", "Price per share", "Share nav", "Rate MUR → EUR"].includes(
        key
      ) &&
      !key.includes("Rate")
    ) {
      return formatNum(value, 2);
    }
  }

  // Liens
  const linkMap = {
    Instrument: ids?.product_id && `/${appName}/products/${ids.product_id}`,
    "Related Loan":
      ids?.product2_id && `/${appName}/products/${ids.product2_id}`,
    "Asset account":
      ids?.asset_account_id &&
      `/${appName}/asset_accounts/${ids.asset_account_id}`,
    Entity: ids?.entity_id && `/${appName}/entities/${ids.entity_id}`,
    Currency: ids?.currency_id && `/${appName}/currencies/${ids.currency}`,
  };

  if (linkMap[key]) {
    return <LinkWrapper to={linkMap[key]}>{value}</LinkWrapper>;
  }

  if (
    (key === "Collateral" || key === "Related collateral") &&
    ids?.collateral_id
  ) {
    return (
      <LinkWrapper
        to={`/${appName}/collaterals/${ids.collateral_id}`}
        onClick={(e) => {
          e.preventDefault();
          window.location.href = `${backUrl}/collaterals/${ids.collateral_id}`;
        }}
      >
        {value}
      </LinkWrapper>
    );
  }

  if (
    key === "IBAN" ||
    key === "Informations prestataire" ||
    key === "Informations complémentaires" ||
    key === "Signature email" ||
    key === "Chèque (adresse)"
  )
    return <div dangerouslySetInnerHTML={{ __html: value }} />;
  if (key === "URL du bug")
    return <div dangerouslySetInnerHTML={{ __html: value }} />;
  if (key === "URL of the bug")
    return <div dangerouslySetInnerHTML={{ __html: value }} />;
  if (key === "Corps")
    return <div dangerouslySetInnerHTML={{ __html: value }} />;
  // Badges avec style amélioré
  const badges = {
    Alive: { bg: "linear-gradient(135deg, #28a745, #20c997)", color: "white" },
    "Dossier complet": {
      bg: "linear-gradient(135deg, #33A133, #28a745)",
      color: "white",
    },
    "Dossier validé": {
      bg: "linear-gradient(135deg, #66C266, #33A133)",
      color: "white",
    },
    Terminated: {
      bg: "linear-gradient(135deg, #dc3545, #fd7e14)",
      color: "white",
    },
  };

  const pendingStates = [
    "En attente",
    "Commercialisation",
    "Optionnelle - à confirmer",
    "En cours",
  ];

  if (badges[value] || pendingStates.includes(value)) {
    const style = badges[value] || {
      bg: "linear-gradient(135deg, #17a2b8, #6f42c1)",
      color: "white",
    };
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: style.bg,
          color: style.color,
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  if (value === true)
    return (
      <span className="text-success fw-semibold" style={{ fontSize: "0.8rem" }}>
        ✓
      </span>
    );
  if (value === false)
    return (
      <span className="text-danger fw-semibold" style={{ fontSize: "0.8rem" }}>
        ✗
      </span>
    );

  return (
    <span className="text-dark" style={{ fontSize: "0.8rem" }}>
      {value}
    </span>
  );
};

export default IdentificationCard;
